import React, {useState} from "react";
import CardOrderRule from "./CardOrderRule";
import {IOrderRule} from "../../../../../store/trafficManagement/orderRules/types";
import FormCardOrderRule from "./FormCardOrderRule";
import {Button} from "reactstrap";
import FeatherIcon from "feather-icons-react";
import usePermissions from "../../../../../hooks/usePermissions";

interface ListOrderRuleProps {
    orderRules: IOrderRule[];
    invalidateOrderRules?: () => Promise<void>;
}

const ListOrderRule: React.FC<ListOrderRuleProps> = ({orderRules, invalidateOrderRules}) => {
    const {hasPermission} = usePermissions();

    const [isCreating, setIsCreateRule] = useState<boolean>(false)
    const [editRuleId, setEditRuleId] = useState<number | null>(null)

    const handleCreateRule = () => {
        setIsCreateRule(true)
        setEditRuleId(null)
    }

    const handleEditRule = (id: number) => {
        setIsCreateRule(false)
        setEditRuleId(id)
    }

    const handleCloseRule = () => {
        setIsCreateRule(false)
        setEditRuleId(null)
    }

    return (
        <>
            {hasPermission('create-traffic-rules') && (
                isCreating ?
                    <FormCardOrderRule onClose={handleCloseRule} invalidateOrderRules={invalidateOrderRules}/> : (
                        <div className="d-flex">
                            <Button className="d-flex align-items-center gap-2 p-2 mb-3" color="light"
                                    onClick={handleCreateRule}
                                    disabled={!hasPermission('create-traffic-rules')}>
                                <FeatherIcon icon="plus-circle" size={22} strokeWidth={1.5}/> Create Rule
                            </Button>
                        </div>
                    )
            )}

            {orderRules.map((rule) => {
                if (editRuleId === rule.id)
                    return <FormCardOrderRule key={rule.id} orderRuleId={editRuleId} onClose={handleCloseRule}
                                              invalidateOrderRules={invalidateOrderRules}/>

                return <CardOrderRule key={rule.id} orderRule={rule} onEdit={handleEditRule}
                                      invalidateOrderRules={invalidateOrderRules}/>
            })}
        </>
    )
}

export default ListOrderRule